function Contact() {
  return (
    <>
      <header className="header">
        <h1>Contact</h1>
      </header>
      <section className="contact">
        <p>send emails to sacha.beaumier@gmail.com</p>
      </section>
    </>
  )
}

export default Contact
